import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { MODULE } from '@/constant/common';
import router from '@/router';
import store from '@/store';
import storeType from '@/store/modules/common/store-type';
import { defaultLanguage, getActualLanguage, getLocale, languages } from '@/utils/language';
import { ElLoading } from 'element-plus';
import { createI18n } from 'vue-i18n';
const i18n = createI18n({
  locale: getLocale(),
  legacy: false,
  globalInjection: true,
  fallbackLocale: defaultLanguage,
  messageResolver: (locale, key) => {
    const getLocaleMsg = key => key.split('.').reduce((o, k) => o?.[k], locale);
    const replaceTemplate = text => {
      return text.replace(/{([A-z0-9.-]+?)}/g, (...arg) => {
        const msg = getLocaleMsg(arg[1]);
        return typeof msg === 'string' ? replaceTemplate(msg) : arg[0];
      });
    };
    const rawText = getLocaleMsg(key) || key;
    let matchText = rawText ? replaceTemplate(rawText) : null;
    if (!key.startsWith('@k@i@t') && matchText) {
      matchText = matchText.replace(/\{msg\d{1}\}/g, '');
      matchText = matchText?.replace(/([@{}$|])/g, "{'$1'}");
    }
    return matchText;
  },
  messages: {},
  warnHtmlMessage: false
});
setMessage();
const originalT = i18n.global.t;
i18n.global.t = function (key, ...args) {
  if (key === undefined || key === null) {
    return undefined;
  }
  if (key === '') {
    return '';
  }
  return originalT.call(this, key, ...args);
};
export default i18n;
export async function switchLocaleAsync(newLocale) {
  if (i18n.global.locale.value === newLocale) return;
  newLocale = getActualLanguage(newLocale);
  i18n.global.locale.value = newLocale;
  localStorage.setItem('lang', newLocale);
  await setMessage();
  if (localStorage.getItem('authToken')) {
    store.commit(storeType[MODULE.COMMON].MUTATION.CLEAR_ENTITY);
    store.dispatch('user/setAuthBtns', router.currentRoute.value);
  }
  store.commit('app/SET_PAGE_KEY', newLocale + Date.now());
}
export async function setMessage(newLocale = getLocale()) {
  const loadingInstance1 = ElLoading.service({
    fullscreen: true
  });
  const newMessages = await languages[newLocale].message();
  i18n.global.setLocaleMessage(newLocale, newMessages);
  loadingInstance1.close();
}